import React, { Component } from "react";
import { connect } from "react-redux";
import $ from "jquery";

import { Translate, I18n } from "react-redux-i18n";

import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";

import Minimap from "../../utils/components/Minimap";
import ToggleSwitch from "../../utils/components/ToggleSwitch";

import { setAlert } from "../../../actions/alertActions";
import {
  compressImage,
  getParkingType,
  getVehicleType,
  getFacilitiesType,
  parseAddress,
} from "../../utils/Utils";

import camera from "../../../styles/images/camera.svg";
import arrow from "../../../styles/images/arrow_black.svg";
import search from "../../../styles/images/search.svg";
import pencil from "../../../styles/images/pencil.svg";
import cross from "../../../styles/images/cross.svg";
import "../../../styles/components/chargers/modals/ActionCharger.scss";

class ActionCharger extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;

    this.state = {
      validated: false,
      isScrolled: false,

      picture: [],
      chargerName: "",
      address: "",
      chargerSerial: "",
      chargerSerialNumber: "",
      chargerInfrastructureCPE: true,

      coords: null,
      lat: 0,
      lng: 0,
      forceCoords: false,
      locationValue: "",
      query: "",

      accordionToggles: [false, false],
      parkingTypes: [false, false, false, false, false],
      vehicleTypes: [false, false, false, false],
      facilitiesTypes: [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
      ],
      allowBooking: false,
      allowRFID: false,
      allowConfirmation: false,
      chargerInfo: "",
      chargerInternalInfo: "",
      adressEditBool: false,
      allowOfflineNotification: true,
      allowOfflineNotificationEmail: this.props.accountData.email || "",
      chargingDistance: "500",
    };

    this.handleScroll = this.handleScroll.bind(this);
    this.handlePickPicture = this.handlePickPicture.bind(this);
    this.handleRemovePicture = this.handleRemovePicture.bind(this);
    this.handlePictureChange = this.handlePictureChange.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);
    this.handleOnClickAccordion = this.handleOnClickAccordion.bind(this);
    this.handleUpdateQuery = this.handleUpdateQuery.bind(this);
    this.handleUpdateAddress = this.handleUpdateAddress.bind(this);
    this.handleOnSubmit = this.handleOnSubmit.bind(this);
    this.resetState = this.resetState.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.hasOwnProperty("selectedCharger") &&
      this.props.selectedCharger
    ) {
      if (
        prevProps.selectedCharger !== this.props.selectedCharger ||
        prevProps.selectedCharger._id !== this.props.selectedCharger._id
      ) {
        this.safeSetState({
          picture: Array.isArray(this.props.selectedCharger.imageContent)
            ? this.props.selectedCharger.imageContent.map(
              (img) => img + "?v=" + Date.now()
            )
            : this.props.selectedCharger.imageContent + "?v=" + Date.now(),
          chargerName: this.props.selectedCharger.name,
          chargerSerial: this.props.selectedCharger.hwId,
          chargerSerialNumber: this.props.selectedCharger.serialNumber,
          chargerInfrastructureCPE:
            this.props.selectedCharger.CPE === this.props.selectedPlace.CPE,
          chargerCPE: this.props.selectedCharger.CPE ?? "",
          locationValue: parseAddress(this.props.selectedCharger.address),
          coords: this.props.selectedCharger.geometry.coordinates,
          parkingTypes: (() => {
            let arr = new Array(5).fill(false);
            arr[
              getParkingType(this.props.selectedCharger.parkingType).index
            ] = true;
            return arr;
          })(),
          vehicleTypes: (() => {
            let arr = new Array(4).fill(false);
            this.props.selectedCharger.vehiclesType.map(
              (v) => (arr[getVehicleType(v.vehicle).index] = true)
            );
            return arr;
          })(),
          facilitiesTypes: (() => {
            let arr = new Array(20).fill(false);
            this.props.selectedCharger.facilitiesTypes &&
              this.props.selectedCharger.facilitiesTypes.map(
                (v) => (arr[getFacilitiesType(v.facility).index] = true)
              );
            return arr;
          })(),
          allowBooking: this.props.selectedCharger.instantBooking,
          allowRFID: this.props.selectedCharger.allowRFID,
          allowConfirmation: this.props.selectedCharger.requireConfirmation,
          allowOfflineNotificationEmail:
            this.props.selectedCharger.offlineEmailNotification ||
            this.props.accountData.email ||
            "",
          allowOfflineNotification:
            this.props.selectedCharger &&
            this.props.selectedCharger.offlineNotification,
          chargingDistance:
            (this.props.selectedCharger &&
              this.props.selectedCharger.chargingDistance) ||
            "500",
          chargerInfo:
            this.props.selectedCharger.infoPoint ||
            this.props.selectedCharger.infoPoints,
          chargerInternalInfo: this.props.selectedCharger.internalInfo,
        });
      }

      if (
        prevProps.mode !== this.props.mode ||
        prevProps.show !== this.props.show
      ) {
        this.safeSetState({ adressEditBool: false });
      }
    }
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  handleScroll(e) {
    this.safeSetState({
      isScrolled: e.target.scrollTop > 0 ? true : false,
    });
  }

  handlePickPicture(e) {
    document.getElementById("file-picker").click();
  }

  handleRemovePicture(file) {
    this.safeSetState({
      picture: this.state.picture.filter((item) => item !== file),
    });
  }

  handlePictureChange(e) {
    let files = e.target.files;
    let filesArr = Array.prototype.slice.call(files);
    let imagesValid = true;

    filesArr.forEach(function (file) {
      if (file.type === "image/png" || file.type === "image/jpeg") {
      } else {
        imagesValid = false;
      }
    });

    if (imagesValid) {
      if (filesArr.length + this.state.picture.length > 5) {
        this.props.setAlert(
          I18n.t("myChargersEditCharger_numMaxPhoto"),
          "danger"
        );
        return;
      }

      filesArr.map((file) =>
        compressImage(file).then((picture) => {
          this.safeSetState({ picture: [...this.state.picture, picture] });
        })
      );
    } else {
      this.props.setAlert(
        I18n.t("myChargersNewCharger_invalidChargerLocation"),
        "danger"
      );
    }

  }

  handleOnChange(e) {
    this.safeSetState({
      [e.target.name]: e.target.value,
    });
  }

  handleOnClickAccordion(e) {
    let toggles = [false, false];
    toggles[$(e.target).parent(".card").index()] =
      !this.state.accordionToggles[$(e.target).parent(".card").index()];
    this.safeSetState({ accordionToggles: toggles });
  }

  handleUpdateQuery() {
    if (this.state.locationValue !== "")
      this.safeSetState({
        query: this.state.locationValue,
      });
  }

  handleUpdateAddress({ address, coords }, callback) {
    this.safeSetState(
      {
        ...(address && { locationValue: address }),
        ...(address && { address }),
        lat: coords[1],
        lng: coords[0],
        coords,
        forceCoords: false,
      },
      callback
    );
  }

  handleOnSubmit(e) {
    e.preventDefault();
    const form = $(e.target)[0];
    this.safeSetState({ validated: true }, () => {
      if (form.checkValidity() !== false) {
        if (
          this.state.parkingTypes.findIndex((p) => p) !== -1 &&
          this.state.vehicleTypes.findIndex((p) => p) !== -1 &&
          this.state.facilitiesTypes.findIndex((p) => p) !== -1
        ) {
          if (this.props.mode === "add") {
            if (this.state.picture.length === 0) {
              this.props.setAlert(
                I18n.t("myChargersNewCharger_missingPhoto"),
                "danger"
              );
              return;
            }

            this.props.onSubmit(
              form,
              { address: this.state.address, coords: this.state.coords },
              this.state.parkingTypes,
              this.state.vehicleTypes,
              this.state.facilitiesTypes,
              this.state.picture
            );
          } else {
            if (this.state.adressEditBool)
              if (this.state.query === "") {
                this.props.setAlert(
                  I18n.t("actionCharger_insertValidImage"),
                  "danger"
                );
                return;
              }

            let newPicture = this.state.picture.filter(
              (f) => !this.props.selectedCharger.imageContent.includes(f)
            );

            this.props.onSubmit(
              this.props.selectedCharger.chargerId,
              form,
              {
                address: this.state.adressEditBool
                  ? this.state.address
                  : this.props.selectedCharger.address,
                coords: this.state.adressEditBool
                  ? this.state.coords
                  : this.props.selectedCharger.geometry.coordinates,
              },
              this.state.parkingTypes,
              this.state.vehicleTypes,
              this.state.facilitiesTypes,
              newPicture
            );
          }
        }
      }
    });
  }

  selectParking(i) {
    const parkingTypes = [false, false, false, false, false];
    parkingTypes[i] = true;
    this.safeSetState({
      parkingTypes,
    });
  }

  selectVehicles(i) {
    this.safeSetState((prevState) => ({
      vehicleTypes: [
        ...prevState.vehicleTypes.slice(0, i),
        !prevState.vehicleTypes[i],
        ...prevState.vehicleTypes.slice(i + 1),
      ],
    }));
  }

  selectFacilities(i) {
    this.safeSetState((prevState) => ({
      facilitiesTypes: [
        ...prevState.facilitiesTypes.slice(0, i),
        !prevState.facilitiesTypes[i],
        ...prevState.facilitiesTypes.slice(i + 1),
      ],
    }));
  }

  resetState() {
    this.safeSetState({
      validated: false,
      isScrolled: false,

      picture: [],
      chargerName: "",
      address: "",
      chargerSerial: "",
      chargerSerialNumber: "",
      chargerInfrastructureCPE: true,

      coords: null,
      forceCoords: false,
      locationValue: "",
      query: "",

      accordionToggles: [false, false],
      parkingTypes: [false, false, false, false, false],
      vehicleTypes: [false, false, false, false],
      facilitiesTypes: [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
      ],
      allowBooking: false,
      allowRFID: false,
      allowConfirmation: false,
      chargerInfo: "",
      chargerInternalInfo: "",
    });
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    return (
      <>
        <Modal
          id="actionCharger"
          show={this.props.show}
          onHide={this.props.onHide}
          onExited={this.resetState}
          centered
        >
          <Modal.Header>
            <Modal.Title>
              <Translate
                value={
                  this.props.mode === "add"
                    ? "myChargers_newCharger"
                    : "myChargers_editCharger"
                }
              />
            </Modal.Title>
          </Modal.Header>
          {this.props.mode === "add" && (
            <div className="evio-charger-tip">
              <div className="i-icon">i</div>
              <Translate value="myChargersNewCharger_evioChargerTip" />
            </div>
          )}
          <div
            className={
              "picture-picker-container " +
              (this.state.isScrolled ? "shadowed" : "")
            }
          >
            <input
              id="file-picker"
              type="file"
              accept="image/*"
              multiple
              style={{ display: "none" }}
              onChange={this.handlePictureChange}
            />
            <div className="picture-picker-items">
              {this.state.picture &&
                this.state.picture.map((pic, idx) => (
                  <React.Fragment key={`${pic || "picture"}-${idx}`}>
                    {idx < 5 && (
                      <div className="picture-picker">
                        {this.state.picture.length > 1 && (
                          <button
                            type="button"
                            className="btn-remove-photo"
                            onClick={() => this.handleRemovePicture(pic)}
                          >
                            <img
                              src={cross}
                              className="remove-photo-icon"
                              alt=""
                            />
                          </button>
                        )}
                        <a href={pic} target="_blank" rel="noreferrer">
                          <img id="picture" src={pic} alt="" />
                        </a>
                      </div>
                    )}
                  </React.Fragment>
                ))}
            </div>
            <button
              type="button"
              className="btn-add-photo"
              onClick={this.handlePickPicture}
            >
              <img src={camera} className="camera" alt="" />
              {I18n.t("addEV_add")}
            </button>
          </div>
          <Modal.Body onScroll={this.handleScroll}>
            <Form
              id="charger-form"
              noValidate
              validated={this.state.validated}
              onSubmit={this.handleOnSubmit}
            >
              <Form.Group className="form-field" controlId="chargerName">
                <Form.Label>
                  <Translate value="myChargersNewCharger_name" />
                </Form.Label>
                <Form.Control
                  type="text"
                  name="chargerName"
                  value={this.state.chargerName}
                  onChange={this.handleOnChange}
                  required
                />
                <Form.Control.Feedback type="invalid">
                  <Translate value="myChargersNewCharger_invalidChargerName" />
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="form-field" controlId="chargerLocation">
                <div className="location-field">
                  <Form.Label>
                    <Translate value="address_address" />
                  </Form.Label>
                </div>
                <div className="input-container">
                  <Form.Control
                    type="text"
                    name="chargerLocation"
                    placeholder={I18n.t(
                      "myChargersNewCharger_locationPlaceholder"
                    )}
                    value={parseAddress(
                      this.state.locationValue,
                      null,
                      null,
                      false
                    )}
                    onChange={(e) =>
                      this.safeSetState({ locationValue: e.target.value })
                    }
                    onKeyDown={(e) => {
                      if (e.keyCode === 13) this.handleUpdateQuery();
                    }}
                    onKeyUp={(e) => {
                      const input = $(e.target)[0];
                      if (
                        this.state.validated &&
                        parseAddress(this.state.query) !== "" &&
                        parseAddress(this.state.address) !== "" &&
                        parseAddress(this.state.locationValue) !== ""
                      ) {
                        input.setCustomValidity("");
                      } else {
                        input.setCustomValidity(
                          I18n.t("myChargersNewCharger_invalidChargerLocation")
                        );
                      }
                    }}
                    required
                    isValid={
                      this.props.mode !== "edit"
                        ? this.state.validated &&
                        parseAddress(this.state.query) !== "" &&
                        parseAddress(this.state.address) !== "" &&
                        parseAddress(this.state.locationValue) !== ""
                        : this.state.adressEditBool
                          ? this.state.validated &&
                          parseAddress(this.state.query) !== "" &&
                          parseAddress(this.state.address) !== "" &&
                          parseAddress(this.state.locationValue) !== ""
                          : false
                    }
                    isInvalid={
                      this.props.mode !== "edit"
                        ? this.state.validated &&
                        (parseAddress(this.state.address) === "" ||
                          parseAddress(this.state.query) === "" ||
                          parseAddress(this.state.locationValue) === "")
                        : this.state.adressEditBool
                          ? this.state.validated &&
                          (parseAddress(this.state.address) === "" ||
                            parseAddress(this.state.query) === "" ||
                            parseAddress(this.state.locationValue) === "")
                          : false
                    }
                    disabled={
                      this.props.mode === "edit" && !this.state.adressEditBool
                        ? true
                        : false
                    }
                  />

                  {this.props.mode === "edit" && !this.state.adressEditBool ? (
                    <button
                      type="button"
                      className="search-btn clear"
                      onClick={() =>
                        this.safeSetState(
                          { adressEditBool: true },
                          this.handleUpdateQuery
                        )
                      }
                    >
                      <img src={pencil} alt="" />
                    </button>
                  ) : (
                    <button
                      type="button"
                      className="search-btn clear"
                      onClick={this.handleUpdateQuery}
                    >
                      <img src={search} alt="" />
                    </button>
                  )}

                  <Form.Control.Feedback type="invalid">
                    <Translate value="myChargersNewCharger_invalidChargerLocation" />
                  </Form.Control.Feedback>
                </div>
                {this.state.query !== "" && (
                  <>
                    <Minimap
                      charger={this.props.selectedCharger}
                      address={this.state.address}
                      query={this.state.query}
                      coords={this.state.coords}
                      forceCoords={this.state.forceCoords}
                      updateAddress={this.handleUpdateAddress}
                    />
                    <div className="coords-container">
                      <span className="coords-drag-info">
                        <Translate value="myChargersNewCharger_coordsDragInfo" />
                      </span>
                      <Form.Label className="coords-label">
                        <Translate value="myChargersNewCharger_lat" />
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="lat"
                        value={this.state.lat}
                        onChange={(e) => {
                          const lat = e.target.value;
                          this.safeSetState({ lat });
                        }}
                        onKeyDown={(e) => {
                          if (e.keyCode === 13) {
                            e.preventDefault();
                            const { lat, lng } = this.state;
                            this.safeSetState({
                              coords: [lng, lat],
                              forceCoords: true,
                            });
                          }
                        }}
                      />
                      <Form.Label className="coords-label">
                        <Translate value="myChargersNewCharger_lng" />
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="lng"
                        value={this.state.lng}
                        onChange={(e) => {
                          const lng = e.target.value;
                          this.safeSetState({ lng });
                        }}
                        onKeyDown={(e) => {
                          if (e.keyCode === 13) {
                            e.preventDefault();
                            const { lat, lng } = this.state;
                            this.safeSetState({
                              coords: [lng, lat],
                              forceCoords: true,
                            });
                          }
                        }}
                      />
                      <span className="coords-save-info">
                        <Translate value="myChargersNewCharger_coordsSaveInfo" />
                      </span>
                    </div>
                  </>
                )}
              </Form.Group>
              <Form.Group className="form-field">
                <Form.Label>
                  <Translate value="myChargersNewCharger_serial" />
                </Form.Label>
                <Form.Control
                  type="text"
                  name="chargerSerial"
                  value={this.state.chargerSerial}
                  onChange={this.handleOnChange}
                  disabled={
                    this.props.mode === "edit" &&
                      this.props.account.isAdmin !== true
                      ? true
                      : false
                  }
                  required
                />
                <Form.Control.Feedback type="invalid">
                  <Translate value="myChargersNewCharger_invalidChargerSerial" />
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="form-field">
                <Form.Label>
                  <Translate value="myChargersNewCharger_serialNumber" />
                </Form.Label>
                <Form.Control
                  type="text"
                  name="chargerSerialNumber"
                  value={this.state.chargerSerialNumber}
                  onChange={this.handleOnChange}
                />
              </Form.Group>
              <Form.Group className="form-field">
                <Form.Control
                  as={ToggleSwitch}
                  name="chargerInfrastructureCPE"
                  label={
                    <Translate value="myChargersNewCharger_chargerInfrastructureCPE" />
                  }
                  checked={this.state.chargerInfrastructureCPE}
                  onChange={() =>
                    this.safeSetState((prevState) => ({
                      chargerInfrastructureCPE:
                        !prevState.chargerInfrastructureCPE,
                    }))
                  }
                />
              </Form.Group>
              {!this.state.chargerInfrastructureCPE && (
                <Form.Group className="form-field">
                  <Form.Label>
                    <Translate value="myChargersNewCharger_chargerCPE" />
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="chargerCPE"
                    value={this.state.chargerCPE}
                    onChange={this.handleOnChange}
                  />
                  <Form.Control.Feedback type="invalid">
                    <Translate value="myChargersNewCharger_invalidChargerCPE" />
                  </Form.Control.Feedback>
                </Form.Group>
              )}
              <Accordion>
                <Form.Group
                  as={Card}
                  controlId="parking-type"
                  className="form-field"
                >
                  <Accordion.Toggle
                    as={Card.Header}
                    eventKey="0"
                    onClick={this.handleOnClickAccordion}
                  >
                    <Translate value="myChargersNewCharger_parkingType" />
                    <Form.Control
                      as="div"
                      isInvalid={
                        this.state.validated &&
                        this.state.parkingTypes.findIndex((p) => p) === -1
                      }
                      isValid={
                        this.state.parkingTypes.findIndex((p) => p) !== -1
                      }
                      className="preview-icons"
                    >
                      {this.state.parkingTypes.map((p, i) => {
                        const pt = getParkingType(i);
                        return (
                          p && (
                            <img key={pt.name + i} src={pt.borderless} alt="" />
                          )
                        );
                      })}
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      <Translate value="myChargersNewCharger_invalidChargerParkingType" />
                    </Form.Control.Feedback>
                    <img
                      src={arrow}
                      alt=""
                      className={
                        this.state.accordionToggles[0] ? "arrow open" : "arrow"
                      }
                    />
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="0">
                    <Card.Body>
                      <div className="parking-container">
                        {this.state.parkingTypes.map((p, i) => {
                          const pt = getParkingType(i);
                          return (
                            <div
                              key={"parking" + i}
                              className="type-btn"
                              onClick={() => this.selectParking(i)}
                            >
                              <img
                                src={pt[p ? "selected" : "faded"]}
                                alt={I18n.t(`myChargersNewCharger_${pt.name}`)}
                              />
                              <p>
                                <Translate
                                  value={`myChargersNewCharger_${pt.name}`}
                                />
                              </p>
                            </div>
                          );
                        })}
                      </div>
                    </Card.Body>
                  </Accordion.Collapse>
                </Form.Group>
                <Form.Group
                  as={Card}
                  controlId="vehicleType"
                  className="form-field"
                >
                  <Accordion.Toggle
                    as={Card.Header}
                    eventKey="1"
                    onClick={this.handleOnClickAccordion}
                  >
                    <Translate value="myChargersNewCharger_vehicles" />
                    <Form.Control
                      as="div"
                      isInvalid={
                        this.state.validated &&
                        this.state.vehicleTypes.filter((v) => v).length === 0
                      }
                      isValid={
                        this.state.vehicleTypes.filter((v) => v).length > 0
                      }
                      className="preview-icons"
                    >
                      {this.state.vehicleTypes.map((v, i) => {
                        const vt = getVehicleType(i);
                        return (
                          v && (
                            <img key={vt.name + i} src={vt.borderless} alt="" />
                          )
                        );
                      })}
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      <Translate value="myChargersNewCharger_invalidChargerVehicleType" />
                    </Form.Control.Feedback>
                    <img
                      src={arrow}
                      alt=""
                      className={
                        this.state.accordionToggles[1] ? "arrow open" : "arrow"
                      }
                    />
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="1">
                    <Card.Body>
                      <div className="vehicle-container">
                        {this.state.vehicleTypes.map((v, i) => {
                          const vt = getVehicleType(i);
                          return (
                            <div
                              key={"vehicle" + i}
                              className="type-btn"
                              onClick={() => this.selectVehicles(i)}
                            >
                              <img
                                src={vt[v ? "selected" : "faded"]}
                                alt={I18n.t(`myChargersNewCharger_${vt.name}`)}
                              />
                              <p>
                                <Translate
                                  value={`myChargersNewCharger_${vt.name}`}
                                />
                              </p>
                            </div>
                          );
                        })}
                      </div>
                    </Card.Body>
                  </Accordion.Collapse>
                </Form.Group>
                <Form.Group
                  as={Card}
                  controlId="facilitiesType"
                  className="form-field"
                >
                  <Accordion.Toggle
                    as={Card.Header}
                    eventKey="2"
                    onClick={this.handleOnClickAccordion}
                  >
                    <Translate value="myChargersNewCharger_facilities" />
                    <Form.Control
                      as="div"
                      isInvalid={
                        this.state.validated &&
                        this.state.facilitiesTypes.filter((v) => v).length === 0
                      }
                      isValid={
                        this.state.facilitiesTypes.filter((v) => v).length > 0
                      }
                      className="preview-icons"
                    >
                      {this.state.facilitiesTypes.map((v, i) => {
                        const vt = getFacilitiesType(i);
                        return (
                          v && (
                            <img key={vt.name + i} src={vt.borderless} alt="" />
                          )
                        );
                      })}
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      <Translate value="myChargersNewCharger_invalidChargerFacilitiesType" />
                    </Form.Control.Feedback>
                    <img
                      src={arrow}
                      alt=""
                      className={
                        this.state.accordionToggles[1] ? "arrow open" : "arrow"
                      }
                    />
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="2">
                    <Card.Body>
                      <div className="vehicle-container">
                        {this.state.facilitiesTypes.map((v, i) => {
                          const vt = getFacilitiesType(i);
                          return (
                            <div
                              key={"facility" + i}
                              className="type-btn"
                              onClick={() => this.selectFacilities(i)}
                            >
                              <img
                                src={vt[v ? "selected" : "faded"]}
                                alt={I18n.t(`myChargersNewCharger_${vt.name}`)}
                              />
                              <p>
                                <Translate
                                  value={`myChargersNewCharger_${vt.name}`}
                                />
                              </p>
                            </div>
                          );
                        })}
                      </div>
                    </Card.Body>
                  </Accordion.Collapse>
                </Form.Group>
              </Accordion>
              <Form.Group className="form-field" style={{ display: "none" }}>
                <Form.Control
                  as={ToggleSwitch}
                  name="chargerBooking"
                  label={
                    <Translate value="myChargersNewCharger_allowBooking" />
                  }
                  checked={this.state.allowBooking}
                  disabled
                  onChange={() =>
                    this.safeSetState((prevState) => ({
                      allowBooking: !prevState.allowBooking,
                    }))
                  }
                />
              </Form.Group>

              {this.props.selectedCharger &&
                this.props.selectedCharger.partyId &&
                this.props.selectedCharger.operator && (
                  <Form.Group
                    className="form-field"
                    controlId="partyId_operator"
                  >
                    <Form.Label>
                      <Translate value="myChargersNewCharger_partyId_operator" />
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="partyId_operator"
                      value={
                        this.props.selectedCharger.partyId +
                        " - " +
                        this.props.selectedCharger.operator
                      }
                      disabled
                    />
                    <Form.Control.Feedback type="invalid">
                      <Translate value="myChargersNewCharger_invalidChargerName" />
                    </Form.Control.Feedback>
                  </Form.Group>
                )}

              <Form.Group className="form-field" controlId="chargingDistance">
                <Form.Label>
                  <Translate value="myChargersNewCharger_chargingDistance_label" />
                </Form.Label>
                <Form.Control
                  type="number"
                  name="chargingDistance"
                  value={this.state.chargingDistance}
                  onChange={this.handleOnChange}
                  required
                />
                <Form.Control.Feedback type="invalid">
                  <Translate value="myChargersNewCharger_invalidDistance" />
                </Form.Control.Feedback>
              </Form.Group>

              <div className="form-field">
                <ToggleSwitch
                  name="chargerRFID"
                  label={<Translate value="myChargersNewCharger_allowRFID" />}
                  checked={this.state.allowRFID}
                  onChange={() =>
                    this.safeSetState((prevState) => ({
                      allowRFID: !prevState.allowRFID,
                    }))
                  }
                />
              </div>

              <div className="form-field">
                <ToggleSwitch
                  name="allowOfflineNotification"
                  label={
                    <Translate value="myChargersNewCharger_allowOfflineNotification" />
                  }
                  checked={this.state.allowOfflineNotification}
                  onChange={() =>
                    this.safeSetState(
                      (prevState) => ({
                        allowOfflineNotification:
                          !prevState.allowOfflineNotification,
                      }),
                      this.safeSetState({
                        allowOfflineNotificationEmail:
                          (this.props.selectedCharger &&
                            this.props.selectedCharger
                              .allowOfflineNotificationEmail) ||
                          this.props.accountData.email ||
                          "",
                      })
                    )
                  }
                />
              </div>

              {this.state.allowOfflineNotification && (
                <Form.Group
                  className="form-field"
                  controlId="allowOfflineNotificationEmail"
                >
                  <Form.Control
                    type="text"
                    placeholder="evio1@go-evio.com; evio2@go-evio.com"
                    name="allowOfflineNotificationEmail"
                    value={this.state.allowOfflineNotificationEmail}
                    onChange={this.handleOnChange}
                    required
                  />
                </Form.Group>
              )}

              <div className="form-field disabled">
                <p className="description">
                  <Translate value="myChargersNewCharger_allowOfflineNotificationEmail_description" />
                </p>
              </div>

              <div className="form-field disabled" style={{ display: "none" }}>
                <ToggleSwitch
                  name="chargerConfirmation"
                  label={
                    <Translate value="myChargersNewCharger_requireConfirmation" />
                  }
                  checked={this.state.allowConfirmation}
                  onChange={() =>
                    this.safeSetState((prevState) => ({
                      allowConfirmation: !prevState.allowConfirmation,
                    }))
                  }
                  disabled={true}
                />
                <p className="description">
                  <Translate value="myChargersNewCharger_requireConfirmationDesc" />
                </p>
              </div>
              <Form.Group className="form-field">
                <p>
                  <Translate value="myChargersNewCharger_additionalInfo" />
                </p>
                <Form.Control
                  as="textarea"
                  name="chargerInfo"
                  placeholder={I18n.t("myChargersNewCharger_typeHere")}
                  value={this.state.chargerInfo}
                  onChange={this.handleOnChange}
                />
              </Form.Group>
              {this.props.account.isAdmin && (
                <Form.Group className="form-field">
                  <p>
                    <Translate value="myChargersNewCharger_internalInfo" />
                  </p>
                  <Form.Control
                    as="textarea"
                    name="chargerInternalInfo"
                    placeholder={I18n.t("myChargersNewCharger_typeHere")}
                    value={this.state.chargerInternalInfo}
                    onChange={this.handleOnChange}
                  />
                </Form.Group>
              )}
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <button type="submit" form="charger-form">
              <Translate value="myChargersNewCharger_save" />
            </button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  accountData: state.account.accountData,
  account: state.account,
});

export default connect(mapStateToProps, { setAlert })(ActionCharger);
